var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArticlePreviewBorder2 = function SvgArticlePreviewBorder2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 76 438",
    fill: "none",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.462 437.801c-23.122-10.271-25.685-53.462-27.907-90.895-1.607-27.091-3.036-51.166-11.95-57.562-24.83-18.01-15.301-52.815-5.986-86.839 9.623-35.147 19.017-69.461-9.928-83.566-9.419-3.901-17.737-10.998-10.816-40.328 5.555-23.545.674-35.062-3.498-44.905C1.387 24.29-1.955 16.406 5.11.99H0v436.81h75.462ZM18.943 110.982c-1.325.863-3.716-1.047-4.95-3.296-1.728-3.15-2.37-5.212-1.573-7.673.837-4.115 5.37-2.663 6.868.26 1.497 2.923 2.249 9.022-.345 10.709Zm9.711 153.564c1.228 5.915 8.211 14.157 13.458 12.773 5.246-1.384 4.944-11.893 3.716-17.808-1.227-5.915-8.288-15.597-13.535-14.213-5.246 1.384-4.866 13.334-3.639 19.248Z",
    stroke: "#1A1717",
    fill: "#1A1717"
  })));
};

export default SvgArticlePreviewBorder2;